import React from "react"
import { Content } from "components/content/Content"

interface FormSubmissionMessageProps {
  className?: string
  heading: string | null
  subHeading?: string
}

export const FormSubmissionMessage = ({
  heading,
  subHeading,
  className = "",
}: FormSubmissionMessageProps) => {
  return (
    <div className={className} id="form-submitted">
      <h2>{!heading ? "Thank You" : heading}</h2>
      <div style={{ textAlign: "center" }}>
        {subHeading && subHeading !== "<p></p>" ? (
          <Content content={subHeading} />
        ) : (
          "Your Message has Been received"
        )}
      </div>
    </div>
  )
}
